import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';

const ICON_PREFIX = 'storefront/editor/';

export default class StorefrontEditorIcon extends React.PureComponent {
  static propTypes = {
    className: pt.string,
    type: pt.string,
    svgType: pt.string,
    fallback: pt.string,
    withPrefix: pt.bool,
    width: pt.number,
    height: pt.number,
  };

  getIconPath(type) {
    if (!type) {
      return null;
    }

    const { withPrefix = true } = this.props;
    const prefix = withPrefix ? ICON_PREFIX : '';

    return `${prefix}${type}`;
  }

  render() {
    const { type, svgType, fallback } = this.props;

    return (
      <Icon
        {...this.props}
        type={this.getIconPath(type)}
        svgType={this.getIconPath(svgType)}
        fallback={this.getIconPath(fallback)}
      />
    );
  }
}
